<template>
  <div>

      <base-stepper
        v-slot="{changeStep}"
        :numOfSteps="2"
        :initialStep="1"
      >

        <v-stepper-items>
          
          <step-form-content
            title="Pricelist details"
            subTitle="Please enter the details for the new pricelist"
            :schema="schema"
            storeNamespace="services"
            objectNamespace="O_pricelist"
            :step="1"
            :listOnSave="true"
            listObjectNamespace="A_pricelist"
            listStoreNamespace="pricepackages"
            :saveOnContinue="true"
            :clearStoreOnCreate="true"
            @step-change="changeStep"
          ></step-form-content>

          <v-stepper-content class="pa-0" 
              :step="2"
          >
            <v-lazy>
              <priceperiod-stepper
                @stepper-done="onDone"
              ></priceperiod-stepper>
            </v-lazy>
          </v-stepper-content>

        </v-stepper-items>
      </base-stepper>

  </div>
</template>

<script>
import StepFormContent from '@/components/form/StepFormContent'
import PriceperiodStepper from '@/modules/Service/components/Pricepackage/PriceperiodStepper.vue'
import {pricelistSchema} from '@/modules/Service/schema/pricelistSchema.js'
export default {
    name: "ServicePricePackageStepper",
    components: {
      StepFormContent,
      PriceperiodStepper
    },
    methods: {
      onDone() {
          this.$emit('stepper-done');
      }
    },
    computed: {
        schema() {
          return this.$helpers.schemaParser(pricelistSchema)
        },

    }
}
</script>

<style>

</style>